import React from 'react';

const Committee = ()=> (
    <div>
        <h2>Honorary Chair</h2>
        <ul>
        <li>Dacheng Tao, The University of Sydney</li>
        </ul>
        <h2>General Chairs</h2>
        <ul>
        <li>Ivan V. Bajić, Simon Fraser University</li>
        <li>Chunyan Miao, Nanyang Tech. University</li>
        </ul>
        <h2>Technical Program Chairs</h2>
        <ul>
        <li>Purang Abolmaesumi, University of British Columbia</li>
        <li>Justin Dauwels, Delft Univ. of Technology</li>
        <li>Stark Draper, University of Toronto</li>
        <li>Parvin Mousavi, Queen’s University</li>
        <li>Dusit Niyato, Nanyang Tech. University</li>
        </ul>
        <h2>Finance Chair</h2>
        <ul>
        <li>Gene Cheung, York University</li>
        <li>Jun Lin, Nanyang Tech. University</li>
        </ul>
        <h2>Local Arrangement Chair</h2>
        <ul>
        <li>Chng Eng Siong, Nanyang Tech. University</li>
        <li>Zehui Xiong, Singapore Universiyt of Tech. and Design</li>
        </ul>
        <h2>Publicity Chair</h2>
        <ul>
        <li>Z. Jane Wang, University of British Columbia</li>
        </ul>
        <h2>Publication Chairs</h2>
        <ul>
        <li>Xun Chen, USTC, China</li>
        </ul>

        <h2>SPS Liaison</h2>
        <ul>
            <li>Sharon Gannot, Bar-Ilan University</li>
        </ul>
        <h2>International Liaison Chair</h2>
        <ul>
        <li>Yiqiang Chen, Chinese Academy of Sciences</li>
        </ul>
        <h2>Special Advisor</h2>
        <ul>
            <li>Rabab Ward, University of British Columbia</li>
        </ul>
    </div>
);

export default Committee;